import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import AveragePawn from "./average_pawn";
import ActivePawn from "./active_pawn";
import ExpiredPawn from "./expired_pawn";
import PieChartLoader from "../../../../components/extensions/PieChartLoader";

import {
  GetOverallAverage_v4,
  GetOverallActive_v4,
  GetOverallExpired_v4,
} from "../../../../store/actions/reports-v4/sales_service_actions";

import { connect } from "react-redux";
import moment from "moment";
import {
  moduleNames,
  OperationScope,
} from "../../../../helpers/dashboardModuleNames";
import { renderChartTitle } from "../../../../helpers/chartTitleBuilder";
import {
  SetChartSalesAverageTitle,
  SetChartSalesActiveTitle,
  SetChartSalesExpiredTitle,
} from "../../../../store/actions/reports/chart_title_actions";

import { leapYear } from "../../../../helpers/datehelpers";

const currentDate = new Date();
const previousDate = new Date();

const covered_date = new Date();

const getLastMonth = (scopeDate) => {
  var currentMonth = new Date(scopeDate);
  var lastMonth = new Date(scopeDate);

  if (!leapYear(currentMonth.getFullYear() - 1)) {
    lastMonth.setDate(1);
    lastMonth.setMonth(currentMonth.getMonth() - 1);
  } else {
    lastMonth.setDate(1);
  }

  lastMonth.setYear(
    currentMonth.getMonth() === 0
      ? currentMonth.getFullYear() - 1
      : currentMonth.getFullYear()
  );
  return new Date(lastMonth);
};

const getLastYear = (scopeDate) => {
  var currentYear = new Date(scopeDate);
  var lastYear = new Date(scopeDate);
  lastYear.setMonth(currentYear.getMonth());
  lastYear.setYear(currentYear.getFullYear() - 1);
  return new Date(lastYear);
};

const averageFilter = {
  overall: {
    filters: [
      {
        isCurrent: true,
        currentMonth: currentDate.getMonth() + 1,
        currentYear: currentDate.getFullYear(),
        previousMonth: getLastYear(currentDate).getMonth() + 1,
        previousYear: getLastYear(currentDate).getFullYear(),
      },
      {
        isCurrent: true,
        currentMonth: currentDate.getMonth() + 1,
        currentYear: currentDate.getFullYear(),
        previousMonth: getLastMonth(previousDate).getMonth() + 1,
        previousYear: getLastMonth(previousDate).getFullYear(),
      },
    ],
  },
};

const activeFilter = {
  overall: {
    filters: [
      {
        isCurrent: true,
        covered_date: moment(covered_date).format("MMMM DD YYYY"),
      },
    ],
  },
};

const expiredFilter = {
  overall: {
    filters: [
      {
        isCurrent: true,
        covered_date: moment(covered_date).format("MMMM DD YYYY"),
      },
    ],
  },
};

class TotalLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAverageLoading: false,
      isActiveLoading: false,
      isExpiredLoading: false,
      items: [],
      average: averageFilter,
      active: activeFilter,
      expired: expiredFilter,
    };
  }

  PremiseGetAverage = (data) => {
    var month = averageFilter.overall.filters[0].currentMonth - 1;
    var year = averageFilter.overall.filters[0].currentYear;
    var date_param_current = new Date(year, month);

    var chartTitle = renderChartTitle(
      moduleNames.salesAverage,
      OperationScope.overall,
      date_param_current
    );

    this.props.SetChartSalesAverageTitle(chartTitle);

    this.props.GetOverallAverage_v4({
      dates: data,
    });
  };

  PremiseGetActive = (data) => {
    var date_param_current = activeFilter.overall.filters[0].covered_date;

    var chartTitle = renderChartTitle(
      moduleNames.salesActive,
      OperationScope.overall,
      date_param_current
    );

    this.props.SetChartSalesActiveTitle(chartTitle);

    this.props.GetOverallActive_v4({
      dates: data,
    });
  };

  PremiseGetExpired = (data) => {
    var date_param_current = activeFilter.overall.filters[0].covered_date;

    var chartTitle = renderChartTitle(
      moduleNames.salesExpired,
      OperationScope.overall,
      date_param_current
    );

    this.props.SetChartSalesExpiredTitle(chartTitle);

    this.props.GetOverallExpired_v4({
      dates: data,
    });
  };

  componentDidMount() {
    this.setState({
      isAverageLoading: true,
      isActiveLoading: true,
      isExpiredLoading: true,
    });
    Promise.all([
      this.PremiseGetAverage(this.state.average.overall.filters),
      this.PremiseGetActive(this.state.active.overall.filters),
      this.PremiseGetExpired(this.state.expired.overall.filters),
    ]).then((resp) => {
      setTimeout(() => {
        this.setState({
          isAverageLoading: false,
          isActiveLoading: false,
          isExpiredLoading: false,
        });
      }, 1000);
    });
  }

  renderAveragePawn = (data) => {
    return this.state.isAverageLoading ? (
      <PieChartLoader />
    ) : (
      <AveragePawn
        subTitle={this.props.chartTitleAverage}
        listTitle="AVERAGE"
        list={data}
      />
    );
  };

  renderActivePawn = (data) => {
    return this.state.isActiveLoading ? (
      <PieChartLoader />
    ) : (
      <ActivePawn
        subTitle={this.props.chartTitleActive}
        listTitle="ACTIVE"
        list={data}
      />
    );
  };

  renderExpiredPawn = (data) => {
    return this.state.isExpiredLoading ? (
      <PieChartLoader />
    ) : (
      <ExpiredPawn
        subTitle={this.props.chartTitleExpired}
        listTitle="EXPIRED"
        list={data}
      />
    );
  };

  render() {
    return (
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            {this.renderAveragePawn(this.props.average_summary_collection)}
          </Col>
        </Row>
        <hr
          style={{
            position: "relative",
            top: "20px",
            border: "none",
            height: "2px",
            background: "#90A4AE",
            marginBottom: "50px",
          }}
        />
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            {this.renderActivePawn(this.props.active_summary_collection)}
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12}>
            {this.renderExpiredPawn(this.props.expired_summary_collection)}
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    chartTitleAverage: state.chart_title.salesAverage,
    chartTitleActive: state.chart_title.salesActive,
    chartTitleExpired: state.chart_title.salesExpired,

    average_summary_collection: state.sales.average_summary_collection,
    active_summary_collection: state.sales.active_summary_collection,
    expired_summary_collection: state.sales.expired_summary_collection,
  };
};

const mapDispatchToProps = {
  SetChartSalesAverageTitle: SetChartSalesAverageTitle,
  SetChartSalesActiveTitle: SetChartSalesActiveTitle,
  SetChartSalesExpiredTitle: SetChartSalesExpiredTitle,
  GetOverallAverage_v4: GetOverallAverage_v4,
  GetOverallActive_v4: GetOverallActive_v4,
  GetOverallExpired_v4: GetOverallExpired_v4,
};

export default connect(mapStateToProps, mapDispatchToProps)(TotalLayout);
